export default `
@charset "UTF-8";
:host {
  position: relative;
  display: block;
}

input[type=file] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  left: -100px;
}

.selector {
  position: relative;
  box-sizing: border-box;
  border: solid 1px var(--oi-light-active, "#eee");
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 1;
}
.selector::after {
  content: "＋";
  color: var(--oi-light-active);
  border: solid 1px var(--oi-light-active);
  font-size: 3em;
  font-weight: lighter;
  display: block;
  width: 5rem;
  height: 5rem;
  text-align: center;
}

.viewer {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
}
.viewer.multiple {
  position: relative;
}
.viewer .image {
  position: relative;
  box-sizing: border-box;
  border: solid 1px var(--oi-light-active);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.viewer .image::after {
  content: "➹";
  color: var(--oi-light-active, white);
  border: solid 1px var(--oi-light-active);
  font-size: 3em;
  font-weight: lighter;
  display: block;
  width: 5rem;
  height: 5rem;
  text-align: center;
}
.viewer .image .remove {
  position: absolute;
  display: none;
  right: 0;
  top: 0;
  background-color: var(--oi-light);
  border: none;
}
.viewer .image .remove:hover {
  background-color: var(--oi-light-active);
}
.viewer .image .remove::after {
  content: "×";
  font-size: 2em;
}
.viewer .image:hover .remove {
  display: block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiRDpcXOmhueebrlxcT01JSVxcdWlcXHNyY1xcaW1hZ2Utc2VsZWN0b3IiLCJzb3VyY2VzIjpbImluZGV4LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0VBQ0k7RUFDQTs7O0FBR0o7RUFDSTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFJSjtFQUNJO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNJO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBU1I7RUFDSTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNJOztBQUVKO0VBQ0k7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNJO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFTSjtFQUNJO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNJOztBQUdKO0VBQ0k7RUFDQTs7QUFLUjtFQUNJIn0= */`;
